import {
  baseVendorApiSettingsDefaults,
  defaultHttpAgentSettings,
  defaultPaginationSettings,
  defaultRateLimitationSettings,
  defaultSessionSettings,
  defaultVendorApiHttpAdvancedSettings,
} from './base';
import type { CiscoApicApiSettingsDefaults } from './types';

export const ciscoApicDefaults: CiscoApicApiSettingsDefaults = {
  ...baseVendorApiSettingsDefaults,
  ...defaultHttpAgentSettings,
  ...defaultPaginationSettings,
  ...defaultRateLimitationSettings,
  ...defaultSessionSettings,
  ...defaultVendorApiHttpAdvancedSettings,
  defaultPageSize: 100_000,
  maxConcurrentRequests: 10,
};
